import { Tooltip, Typography } from '@mui/material'
import RefreshBtn from '../../../common-images/app-logo/RefreshBtn'

interface ReloadBtnProps {
  reCall?: boolean
  fullLoading?: boolean
  setReCall?: React.Dispatch<React.SetStateAction<boolean>> | any
}

const ReloadBtn = ({ reCall, setReCall, fullLoading }: ReloadBtnProps) => {
  return (
    <Tooltip
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: '#707e8c',
            cursor: fullLoading ? 'not-allowed' : 'pointer'
          }
        }
      }}
      title={<Typography>Reload</Typography>}
    >
      <div
        className={`reload-btn me-2 ${fullLoading ? '!cursor-not-allowed' : 'cursor-pointer'} `}
        onClick={() => {
          if (!fullLoading)
            if (!reCall) {
              setReCall((prev: any) => !prev)
            }
        }}
        data-testid='testid_reload_button'
      >
        <RefreshBtn reCall={reCall} />
      </div>
    </Tooltip>
  )
}

export default ReloadBtn
